import React, { useState } from "react";
import { Check, Copy, Eye, Link2, Pause, Play, Trophy } from "lucide-react";
import { TooltipButton } from "./TeacherMocksShared";
import { statusLabel } from "./teacherMocksHelpers";

export default function TeacherMockRow({ mock, onToggleEnabled, onOpenLink, onView, onCopy, onRanking, isToggling, isHighlighted }) {
  const [linkCopied, setLinkCopied] = useState(false);

  function handleCopyLink() {
    onOpenLink(mock);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 1800);
  }

  return (
    <tr className={isHighlighted ? "tprof-draft-row--highlighted" : undefined}>
      <td>
        <div className="tprof-sim-name-row">
          <div className="tprof-sim-main">
            <div className="tprof-sim-name">{mock.name}</div>
            <div className="tprof-course">{mock.course}</div>
          </div>
          <span className={`tprof-badge tprof-badge-${mock.status}`}>
            {statusLabel(mock.status)}
          </span>
        </div>
      </td>
      <td>
        <span className="tprof-copy">
          {mock.id}
          <Copy size={11} strokeWidth={1.8} aria-hidden="true" />
        </span>
      </td>
      <td>{mock.createdAt}</td>
      <td style={{ color: "#0F172A", fontWeight: 500, textAlign: "center" }}>{mock.questions}</td>
      <td>
        <div className="tprof-progress">
          <div className="tprof-score">
            {mock.answered}
            {mock.totalStudents > 0 && <small> {mock.totalStudents}</small>}
          </div>
          {mock.totalStudents > 0 && (
            <div className="tprof-progress-bar">
              <span
                className="tprof-progress-fill"
                style={{
                  width: `${Math.min(100, Math.round((mock.answered / mock.totalStudents) * 100))}%`,
                  background: mock.answered / mock.totalStudents < 0.5 ? "rgb(148, 163, 184)" : undefined,
                }}
              />
            </div>
          )}
        </div>
      </td>
      <td>
        <div className="tprof-score">
          {mock.average}
          <small>/{mock.questions}</small>
        </div>
        <div className="tprof-score-sub">{mock.averagePercent}</div>
      </td>
      <td style={{ color: "#0F172A", fontWeight: 500, textAlign: "center" }}>{mock.duration}</td>
      <td>
        <div className="tprof-actions">
          <TooltipButton
            className={`tprof-text-action${mock.status === "enabled" ? " tprof-text-action-danger" : " tprof-text-action-success"}`}
            label={mock.status === "enabled" ? "Desabilitar" : "Habilitar"}
            disabled={isToggling}
            onClick={() => onToggleEnabled(mock)}
          >
            {mock.status === "enabled" ? <Pause size={12} aria-hidden="true" /> : <Play size={12} aria-hidden="true" />}
            <span>{isToggling ? "Aguarde..." : mock.status === "enabled" ? "Desabilitar" : "Habilitar"}</span>
          </TooltipButton>
          <TooltipButton
            className={`tprof-icon-action${linkCopied ? " tprof-icon-action-success" : ""}`}
            label={linkCopied ? "Link copiado!" : "Copiar link do simulado"}
            onClick={handleCopyLink}
          >
            {linkCopied ? <Check size={14} aria-hidden="true" /> : <Link2 size={14} aria-hidden="true" />}
          </TooltipButton>
          <TooltipButton
            className="tprof-icon-action"
            label="Visualizar simulado"
            onClick={() => onView(mock)}
          >
            <Eye size={14} aria-hidden="true" />
          </TooltipButton>
          <TooltipButton
            className="tprof-icon-action"
            label="Duplicar simulado"
            onClick={() => onCopy(mock)}
          >
            <Copy size={14} aria-hidden="true" />
          </TooltipButton>
          <TooltipButton
            className="tprof-icon-action tprof-icon-action-warning"
            label="Ver ranking"
            disabled={!mock.hasRanking}
            onClick={() => onRanking(mock)}
          >
            <Trophy size={14} aria-hidden="true" />
          </TooltipButton>
        </div>
      </td>
    </tr>
  );
}
